var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 15.5V5.5H6.75V15.5H5.5ZM14.8125 15.4375L9.9375 10.5625L14.8125 5.6875L15.7083 6.58333L11.7292 10.5625L15.7083 14.5417L14.8125 15.4375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationStart);
export default __webpack_public_path__ + "static/media/paginationStart.88864b55cc7b5f9163d50aacd0543784.svg";
export { ForwardRef as ReactComponent };